module.exports = __webpack_public_path__ + "static/media/thanks_for_pay.3ccf3dcb.png";